import { useRouter } from "next/router";

import { twMerge } from "tailwind-merge";
import { useTimeout } from "usehooks-ts";

import CustomCard from "components/CustomCard";
import useSignInSignUp from "components/SignInSignUpModal/useSignInSignUp";
import { Tab, Tabs } from "components/Tabs";
import useAuthentication from "hooks/useAuthentication";

import DashboardPageInsightList from "../DashboardPageInsightList";

const DashboardPageMyActivitySignUp = ({ collection }: any) => {
  const { authenticated } = useAuthentication();
  const { toggleModal } = useSignInSignUp();

  const description =
    collection === "recently-read"
      ? "Easily find content you read previously"
      : collection === "bookmarked"
      ? "Revisit content you saved to read later"
      : "Revisit content you found particularly valuable or actionable";

  useTimeout(() => {
    if (!authenticated) toggleModal("sign-up");
  }, 15000);

  return (
    <>
      <CustomCard className="mt-[15px] text-center italic text-[18px]">
        <p>{description}.</p>
        <p>
          <span
            onClick={() => toggleModal("sign-up")}
            className="text-smart-teal hover:text-smart-teal cursor-pointer"
          >
            Sign up
          </span>{" "}
          to create your Free Preview Pass.
        </p>
      </CustomCard>
    </>
  );
};

const DashboardPageMyActivity = () => {
  const router = useRouter();
  const collection = router.query.collection as string;
  const { authenticated } = useAuthentication();

  return (
    <>
      <Tabs>
        <Tab
          href="/dashboard?collection=recently-read"
          active={collection === "recently-read"}
        >
          Recently Read
        </Tab>
        <Tab
          href="/dashboard?collection=bookmarked"
          active={collection === "bookmarked"}
        >
          Saved
        </Tab>
        <Tab href="/dashboard?collection=liked" active={collection === "liked"}>
          Liked
        </Tab>
      </Tabs>
      {authenticated ? (
        <CustomCard
          className={twMerge("p-0", true ? "mt-[15px]" : "mt-[45px]")}
        >
          <DashboardPageInsightList
            options={{
              filter: { collection },
              showTopPicksToggle: true,
              showSearch: true,
            }}
          />
        </CustomCard>
      ) : (
        <DashboardPageMyActivitySignUp collection={collection} />
      )}
    </>
  );
};

export default DashboardPageMyActivity;
